<ng-container *ngIf="!accountLoading && (account$ | async) as account; else contentLoading">

  <p class="mt-0 mb-3 text-sm text-600">
    The site's navigation, in the order shown here. Removing every menu in a group falls the site
    back to its built-in navigation. Changes reach the site with the next publish.
  </p>

  <div *ngFor="let location of ['header', 'footer']" class="mb-4">
    <div class="flex align-items-center justify-content-between border-bottom-1 border-200 mb-2">
      <h3 class="text-500 my-2">{{ location === 'header' ? 'Header menu' : 'Footer menu' }}</h3>
      <button pButton pRipple type="button" [label]="location === 'header' ? 'Add group' : 'Add column'"
        icon="pi pi-plus" class="p-button-text p-button-sm" (click)="onAdd($any(location))"></button>
    </div>

    <table class="w-full" style="border-collapse: collapse">
      <tr *ngFor="let menu of menusAsList(account.data?.content, $any(location)); let i = index; let last = last"
          class="border-bottom-1 border-100">
        <td class="py-2"><strong>{{ menu.name || '(unnamed)' }}</strong></td>
        <td class="py-2 text-500 text-sm">{{ itemCount(menu) }} link(s)</td>
        <td class="py-2 text-right" style="width: 12rem">
          <button pButton pRipple type="button" icon="pi pi-chevron-up" class="p-button-rounded p-button-text p-button-sm"
            [disabled]="i === 0 || saving" (click)="onMove(menu, -1, account.data?.content)" title="Move up"></button>
          <button pButton pRipple type="button" icon="pi pi-chevron-down" class="p-button-rounded p-button-text p-button-sm"
            [disabled]="last || saving" (click)="onMove(menu, 1, account.data?.content)" title="Move down"></button>
          <button pButton pRipple type="button" icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-sm"
            (click)="onEdit(menu)" title="Edit"></button>
          <button pButton pRipple type="button" icon="pi pi-trash" class="p-button-rounded p-button-text p-button-danger p-button-sm"
            (click)="onDelete(menu)" title="Remove"></button>
        </td>
      </tr>
    </table>

    <p *ngIf="!menusAsList(account.data?.content, $any(location)).length" class="text-500 text-sm mt-2">
      <span *ngIf="!loadFailed">None yet — the site is using its built-in {{ location }} navigation.</span>
      <span *ngIf="loadFailed" class="app-text-overdue">The content couldn't be loaded — this list is empty because of an error.</span>
    </p>
  </div>

</ng-container>

<ng-template #contentLoading>
  <div class="flex flex-column align-items-center justify-content-center p-6 text-500">
    <i class="pi pi-spin pi-spinner text-3xl mb-3" aria-hidden="true"></i>
    <span>Loading…</span>
  </div>
</ng-template>
